// Updated CreateAbha.js with step persistence using localStorage
import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import CountUp from "react-countup";

import MobileVerify from "../Mobile-verify/mobile-verify";
import MobileOtp from "../Mobile-otp/mobile-otp";
import Patient from "../Patient/patient";
import ConfirmDetail from "../Confirm-detail/confirm-details";
import AdharNumber from "../Adhar-number/adhar-number";
import AdhaOtp from "../Adhar-otp/adhar-otp";
import AbhaAddress from "../Abha-address/abha-address";
import AbhaCard from "../Abha-card/abha-card";
import AadharCard from "../aadhar-card/aadhar-card";
import MobileVerifyOtp from "../Mobile-verify-otp/mobile-verify-otp";

import lab from "../../assets/image/lab.png";
import About_Us_Feature from "../../assets/image/About_Us_Feature.png";
import globeIcon from "../../assets/image/globe.png";
import Card from "../../assets/image/Image.png";
import about from "../../assets/image/about_nha_pg_logo-2.png";
import benefits from "../../assets/image/benefits.png";
import benefits2 from "../../assets/image/benefits2.png";
import benefits3 from "../../assets/image/benefits3.png";
import benefits4 from "../../assets/image/benefits4.png";
import benefits5 from "../../assets/image/benefits5.png";
import benefits6 from "../../assets/image/benefits6.png";
import googleplay from "../../assets/image/google-play.png";
import appstore from "../../assets/image/app-stor.png";
import { setAbhaLoader } from "../../redux/slices/abhaSlice";
import { useSelector } from "react-redux";
import MobileVerification from "../Adhar-otp/mobile-verification";
import { current } from "@reduxjs/toolkit";
import LoginMobileOTP from "../Mobile-verify/mobile-verify";
import LoginMobileOTPSend from "../Mobile-verify/mobile-verify";
import LoginMobileOtpVerify from "../Mobile-otp/mobile-otp";
import PatientList from "../Patient/patient";
import ConfirmPatientDetail from "../Confirm-detail/confirm-details";
import SendAdharOTP from "../Adhar-number/adhar-number";
import VerifyAdhaOtp from "../Adhar-otp/adhar-otp";
import MobileVerificationOTPSend from "../Adhar-otp/mobile-verification";
import MobileVerificationOTPVerify from "../Mobile-verify-otp/mobile-verify-otp";
import AbhaSuggestions from "../Abha-address/abha-address";
import PerferredAbhaOptions from "../Adhar-otp/PerferredAbhaOptions";
import MobileUpdateOTPSend from "../change-mobile";
import MobileVerificationOTPVerifyToUpdateContact from "../change-mobile/verification-screen";
import iconLink from "../../assets/image/Icon_awesome-link.png";
import iconMedical from "../../assets/image/289cbfe83aaebaafd22e8b31a4942e3cc4a77d42.png";
import iconId from "../../assets/image/bf1819560cced77a2ace5429d8bc2d6b3c4e815b.png";
import ServiceCard from "../../components/Servicecard";
import StatsSection from "../../components/Statssection";

const CreatAbha = ({ onNavigate }) => {
  const [sendOtpFunction, setSendOtpFunction] = useState(() => () => { });
  const [mobileOTPSent, setMobileOTPSent] = useState(false);
  const [isMobileVerified, setIsMobileVerified] = useState(false);
  const [currentStep, setCurrentStep] = useState("LoginMobileOTPSend");
  const [isVerifiedotp, setIsVerifiedOtp] = useState(false);
  const [isPatient, setPatient] = useState(false);
  const [isconfirm, setIsconfirm] = useState(false);
  const [isAdharNumber, setAdharNumber] = useState(false);
  const [isAdharOtp, setAdharOtp] = useState(false);
  const [mobileVerificationOTPSent, setMobileVerificationOTPSent] =
    useState(false);
  const [isAdhaaddress, setAdhaaddress] = useState(false);
  const [isVerifiedMobileOTP, setMobileverifyOtp] = useState(false);
  const handleClick = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const { formRef, userData } = useOutletContext();

  const loader = useSelector((state) => state.user.loading);

  // console.log("isVerified", isAdharNumber);

  const globalCurrentStepp = useSelector(
    (state) => state.user.globalCurrentStep
  );

  const stepOrder = [
    "LoginMobileOTPSend",
    "LoginMobileOtpVerify",
    "PatientList",
    "ConfirmPatientDetail",
    "SendAdharOTP",
    "VerifyAdhaOtp",
    "MobileVerificationOTPSend",
    "MobileVerificationOTPVerify",
    "AbhaSuggestions",
    "AbhaCard"
  ];

  useEffect(() => {
    if (userData && Object.keys(userData).length > 0) {
      setCurrentStep("ConfirmPatientDetail");
    }
  }, [userData]);

  const handleBack = () => {
    const currentIndex = stepOrder.indexOf(currentStep);
    if (currentIndex > 0) {
      const prevStep = stepOrder[currentIndex - 1];
      setCurrentStep(prevStep);
    }
  };
  useEffect(() => {
    if (globalCurrentStepp) {
      setCurrentStep(globalCurrentStepp);
    }
  }, [globalCurrentStepp]);
  // const handleBack = () => {
  //   console.log("object");
  //   if (isAdhaaddress) setAdhaaddress(false);
  //   else if (isVerifiedMobileOTP) setMobileverifyOtp(false);
  //   else if (isAdharOtp) setAdharOtp(false);
  //   else if (isAdharNumber) setAdharNumber(false);
  //   else if (isconfirm) setIsconfirm(false);
  //   else if (isPatient) setPatient(false);
  //   else if (isVerifiedotp) setIsVerifiedOtp(false);
  //   else if (isMobileVerified) setIsMobileVerified(false);
  // };

  return (
    <>
      {loader && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            pointerEvents: "all"
          }}
        >
          {" "}
        </div>
      )}
      {currentStep === "LoginMobileOTPSend" && (
        <div ref={formRef}>
          <LoginMobileOTPSend
            setIsMobileVerified1={setIsMobileVerified}
            setMobileOTPSent={setMobileOTPSent}
            setIsVerifiedOtp={setIsVerifiedOtp}
            setCurrentStep={setCurrentStep}
          />
        </div>
      )}

      {currentStep === "LoginMobileOtpVerify" && (
        <div ref={formRef}>
          <LoginMobileOtpVerify
            setIsVerifiedOtp={setIsVerifiedOtp}
            setMobileOTPSent={setMobileOTPSent}
            setCurrentStep={setCurrentStep}
          />
        </div>
      )}

      {currentStep === "PatientList" && (
        <div ref={formRef}>
          <PatientList
            isVerifiedotp={isVerifiedotp}
            setPatient={setPatient}
            setCurrentStep={setCurrentStep}
          />
        </div>
      )}
      {currentStep === "ConfirmPatientDetail" && (
        <div ref={formRef}>
          <ConfirmPatientDetail
            userData={userData}
            isPatient={isPatient}
            setIsconfirm={setIsconfirm}
            handleBack={handleBack}
            setPatient={setPatient}
            setCurrentStep={setCurrentStep}
          />
        </div>
      )}
      {(currentStep === "SendAdharOTP" ||
        currentStep === "AlreadyAbhaNumber") && (
          <div ref={formRef}>
            <SendAdharOTP
              isconfirm={isconfirm}
              setAdharNumber={setAdharNumber}
              setPatient1={setPatient}
              setCurrentStep={setCurrentStep}
            />
          </div>
        )}

      {currentStep === "VerifyAdhaOtp" && (
        <div ref={formRef}>
          <VerifyAdhaOtp
            isAdharNumber={isAdharNumber}
            setAdharNumber={setAdharNumber}
            setAdharOtp={setAdharOtp}
            setIsConfirm1={setIsconfirm}
            setSendOtpFunction={setSendOtpFunction}
            sendOtpFunction={sendOtpFunction}
            setMobileverifyOtp={setMobileverifyOtp}
            setCurrentStep={setCurrentStep}
          />
        </div>
      )}
      {currentStep === "MobileVerificationOTPSend" && (
        <div ref={formRef}>
          <MobileVerificationOTPSend
            setMobileverifyOtp={setMobileverifyOtp}
            setAdharNumber={setAdharNumber}
            setAdharOtp={setAdharOtp}
            setMobileVerificationOTPSent1={setMobileVerificationOTPSent}
            setCurrentStep={setCurrentStep}
          />
        </div>
      )}
      {currentStep === "changeMobile" && (
        <div ref={formRef}>
          <MobileUpdateOTPSend
            setMobileverifyOtp={setMobileverifyOtp}
            setAdharNumber={setAdharNumber}
            setAdharOtp={setAdharOtp}
            setMobileVerificationOTPSent1={setMobileVerificationOTPSent}
            setCurrentStep={setCurrentStep}
          />
        </div>
      )}
      {currentStep === "MobileVerificationOTPVerify" && (
        <div ref={formRef}>
          <MobileVerificationOTPVerify
            isAdharOtp={isAdharOtp}
            setMobileverifyOtp={setMobileverifyOtp}
            setMobileVerificationOTPSent1={setMobileVerificationOTPSent}
            setIsconfirm={setIsconfirm}
            setCurrentStep={setCurrentStep}
          />
        </div>
      )}
      {currentStep === "MobileVerificationOTPVerifyToUpdateContact" && (
        <div ref={formRef}>
          <MobileVerificationOTPVerifyToUpdateContact
            isAdharOtp={isAdharOtp}
            setMobileverifyOtp={setMobileverifyOtp}
            setMobileVerificationOTPSent1={setMobileVerificationOTPSent}
            setIsconfirm={setIsconfirm}
            setCurrentStep={setCurrentStep}
          />
        </div>
      )}
      {currentStep === "PerferredAbhaOptions" && (
        <div ref={formRef}>
          <PerferredAbhaOptions setCurrentStep={setCurrentStep} />
        </div>
      )}
      {currentStep === "AbhaSuggestions" && (
        <div ref={formRef}>
          <AbhaSuggestions
            isVerifiedMobileOTP={isVerifiedMobileOTP}
            setAdhaaddress={setAdhaaddress}
            setMobileVerificationOTPSent1={setMobileVerificationOTPSent}
            setCurrentStep={setCurrentStep}
          />
        </div>
      )}
      {currentStep === "AbhaCard" && (
        <div ref={formRef}>
          <AbhaCard
            isAdhaaddress={isAdhaaddress}
            setCurrentStep={setCurrentStep}
          />
        </div>
      )}

      {/* ######################################################## */}
      {/* {!mobileOTPSent && !isMobileVerified && (
        <div ref={formRef}>
          <MobileOtp
            setIsVerifiedOtp={setIsVerifiedOtp}
            setMobileOTPSent={setMobileOTPSent}
          />
        </div>
      )}
      {mobileOTPSent && (
        <div ref={formRef}>
          <MobileVerify
            setIsMobileVerified1={setIsMobileVerified}
            setMobileOTPSent={setMobileOTPSent}
            setIsVerifiedOtp={setIsVerifiedOtp}
          />
        </div>
      )}

      {isVerifiedotp && (
        <div ref={formRef}>
          <Patient isVerifiedotp={isVerifiedotp} setPatient={setPatient} />
        </div>
      )}
      {isPatient && !isconfirm && (
        <div ref={formRef}>
          <ConfirmDetail
            isPatient={isPatient}
            setIsconfirm={setIsconfirm}
            handleBack={handleBack}
            setPatient={setPatient}
          />
        </div>
      )}
      {isconfirm && !isAdharNumber && (
        <div ref={formRef}>
          <AdharNumber
            isconfirm={isconfirm}
            setAdharNumber={setAdharNumber}
            setPatient1={setPatient}
          />
        </div>
      )}
      {isAdharNumber && !isAdharOtp && (
        <div ref={formRef}>
          <AdhaOtp
            isAdharNumber={isAdharNumber}
            setAdharNumber={setAdharNumber}
            setAdharOtp={setAdharOtp}
            setIsConfirm1={setIsconfirm}
            setSendOtpFunction={setSendOtpFunction}
            sendOtpFunction={sendOtpFunction}
            setMobileverifyOtp={setMobileverifyOtp}
          />
        </div>
      )}
      {isAdharOtp && (
        <div ref={formRef}>
          <MobileVerification
            setMobileverifyOtp={setMobileverifyOtp}
            setAdharNumber={setAdharNumber}
            setAdharOtp={setAdharOtp}
            setMobileVerificationOTPSent1={setMobileVerificationOTPSent}
          />
        </div>
      )}
      {mobileVerificationOTPSent && (
        <div ref={formRef}>
          <MobileVerifyOtp
            isAdharOtp={isAdharOtp}
            setMobileverifyOtp={setMobileverifyOtp}
            setMobileVerificationOTPSent1={setMobileVerificationOTPSent}
            setIsconfirm={setIsconfirm}
          />
        </div>
      )}
      {isVerifiedMobileOTP && !isAdhaaddress && (
        <div ref={formRef}>
          <AbhaAddress
            isVerifiedMobileOTP={isVerifiedMobileOTP}
            setAdhaaddress={setAdhaaddress}
            setMobileVerificationOTPSent1={setMobileVerificationOTPSent}
          />
        </div>
      )}
      {isAdhaaddress ? (
        <div ref={formRef}>
          <AbhaCard isAdhaaddress={isAdhaaddress} />
        </div>
      ) : (
        ""
      )} */}

      {/* ##################################### */}

      {/* {step === "mobile-verify" && (
        <div ref={formRef}>
          <MobileVerify setIsVerified={() => goToNextStep("mobile-otp")} />
        </div>
      )}
      {step === "mobile-otp" && (
        <div ref={formRef}>
          <MobileOtp setIsVerifiedOtp={() => goToNextStep("patient")} />
        </div>
      )}
      {step === "patient" && (
        <div ref={formRef}>
          <Patient setPatient={() => goToNextStep("confirm-detail")} />
        </div>
      )}
      {step === "confirm-detail" && (
        <div ref={formRef}>
          <ConfirmDetail setIsconfirm={() => goToNextStep("adhar-number")} />
        </div>
      )}
      {step === "adhar-number" && (
        <div ref={formRef}>
          <AdharNumber
            setAdharNumber={() => goToNextStep("adhar-otp")}
            setSendOtpFunction={setSendOtpFunction}
            setAdharNumbers={setAdharNumbers}
          />
        </div>
      )}
      {step === "adhar-otp" && (
        <div ref={formRef}>
          <AdhaOtp
            setAdharOtp={() => goToNextStep("mobile-verify-otp")}
            sendOtpFunction={sendOtpFunction}
          />
        </div>
      )}
      {step === "mobile-verify-otp" && (
        <div ref={formRef}>
          <MobileVerifyOtp
            setMobileverifyOtp={() => goToNextStep("aadhar-card")}
          />
        </div>
      )}
      {step === "aadhar-card" && (
        <div ref={formRef}>
          <AadharCard setAadharcart={() => goToNextStep("abha-address")} />
        </div>
      )}
      {step === "abha-address" && (
        <div ref={formRef}>
          <AbhaAddress setAdhaaddress={() => goToNextStep("done")} />
        </div>
      )}
      {step === "done" && (
        <div ref={formRef}>
          <AbhaCard setIsVerifiedMobile={() => goToNextStep("mobile-verify")} />
        </div> */}
      {/* )} */}



      {/* Info and Benefits Section */}
      {/* ===== REPLACE YOUR EXISTING SECTION WITH THIS ===== */}

      <section className="banner-forth-bg abha-info-section">

        <div className="bg-color">

          {/* ── Main hero row ── */}
          <div className="abha-info-inner">

            {/* LEFT: images */}
            <div className="abha-img-group">

              {/* Community-Driven badge */}
              <div className="abha-community-badge">
                <span>Community-<br />Driven</span>
                <div className="abha-globe-btn">
                  <div className="abha-globe-btn">
                    <img src={globeIcon} alt="" aria-hidden="true" />
                  </div>
                </div>
              </div>

              {/* Hand holding ABHA card — LEFT image */}
              <div className="abha-card-frame">
                <img src={Card} alt="ABHA Card" />
              </div>

              {/* PM holding ABHA card — RIGHT image, overlaps left */}
              <div className="abha-pm-frame">
                <img src={About_Us_Feature} alt="PM holding ABHA card" />
                {/* Grid icon overlay — bottom right corner */}

              </div>

            </div>

            {/* RIGHT: content */}
            <div className="abha-info-content">

              {/* Approved row */}
              <div className="abha-approved-row">
                <span className="abha-approved-label">APPROVED BY NHA</span>
                <div className="abha-nha-logo">
                  <img src={about} alt="NHA Logo" />
                </div>
              </div>

              <div className="pathkind-lab">
                <h3>Create AbyM (Health ID)</h3>
              </div>

              <p className="abha-description">
                Be part of Ayushman Bharat Digital Mission (ABDM) and start your
                <br /> digital health journey
              </p>

              {/* CTA row */}
              <div className="abha-cta-row">
                <button className="lik-abha-button" onClick={handleClick}>
                  Create/Link Abha
                </button>
                <button className="abha-play-btn" aria-label="Watch video">
                  <svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z" /></svg>
                </button>
              </div>

            </div>
          </div>

          {/* ── Features bar ── */}
          <div className="abha-features-bar">
            {[
              { icon: iconLink, label: "Link Your ABHA with AbyM Technology" },
              { icon: iconMedical, label: "Choose with whom you want to share your medical records" },
              { icon: iconId, label: "Link your medical records with ABHA" },
            ].map((f, i) => (
              <div className="abha-feat-cell" key={i}>
                <div className="abha-feat-icon">
                  <img src={f.icon} alt="" aria-hidden="true" />
                </div>
                <span className="abha-feat-label">{f.label}</span>
              </div>
            ))}
          </div>

        </div>
      </section>

      <section className="abha-steps-section">
        <div className="container">
          <div className="heading-section">
            <h2>Benefits of ABHA HEALTH card</h2>
            <p>
              Creating ABHA card is the first step towards making digital health
              records safer and more
              <br /> efficient for you and your family.
            </p>
          </div>

          <div className="service-cards-section">
            <div className="container">
              <div className="row justify-content-center align-items-end g-4 g-lg-0 service-cards-row gap-4">

                {/* Left Card */}
                <div className="col-12 col-lg-4">
                  <ServiceCard
                    icon={benefits}
                    title="Digital Health Records"
                    description="All your health information at your fingertips."
                  />
                </div>

                {/* Center Card (Raised — translated up on desktop) */}
                <div className="col-12 col-lg-4">
                  <div className="center-card-raised">
                    <ServiceCard
                      icon={benefits2}
                      title="Personal Health Records(PHR)"
                      description="Connect and integrate your individualhealth records using ABHA to build a comprehensive health history over time."
                      isCenter
                    />
                  </div>
                </div>

                {/* Right Card */}
                <div className="col-12 col-lg-4">
                  <ServiceCard
                    icon={benefits3}
                    title="Consent Based Access"
                    description="Your health data will only be accessed with your clear and informed consent."
                  />
                </div>




              </div>
              <div className="row justify-content-center align-items-end g-4 g-lg-0 service-cards-row gap-4">

                {/* Left Card */}
                <div className="col-12 col-lg-4">
                  <ServiceCard
                    icon={benefits4}
                    title="Secure and Private"
                    description="Designed with robust security and encryption mechanisms, and no information is shared without your permission."
                  />
                </div>

                {/* Center Card (Raised — translated up on desktop) */}
                <div className="col-12 col-lg-4">
                  <div className="center-card-raised">
                    <ServiceCard
                      icon={benefits5}
                      title="Voluntary Opt-In"
                      description="It is not mandatory to carry the ABHA Address card. If you wish to opt-out and request to erase your data at any time, you may do so"
                      isCenter
                    />
                  </div>
                </div>

                {/* Right Card */}
                <div className="col-12 col-lg-4">
                  <ServiceCard
                    icon={benefits6}
                    title="Access to Doctors Digitally"
                    description="By registering for an ABHA Address, you will have access to doctors online securely and safely."
                  />
                </div>




              </div>
            </div>
          </div>
        </div>
      </section>

      <StatsSection />
    </>
  );
};

export default CreatAbha;
